import GlobalMinimalHeader, {
  type GlobalMinimalHeaderContent,
} from '@/components/GlobalMinimalHeader/GlobalMinimalHeader';
import { GlobalNavigationWrapper } from '@/components/GlobalNavigation/GlobalNavigation';
import type {
  GlobalNavContent,
  HeaderContent,
} from '@/contentful/contentful-exports';

import LegacyHeader from '../Legacy/Header/Header';

interface HeaderProps {
  header: HeaderContent | GlobalNavContent | GlobalMinimalHeaderContent;
}

export default function HeaderComponent({ header }: HeaderProps) {
  if (!header) return null;

  switch (header.sys.contentType.sys.id) {
    case 'globalMinimalHeader':
      return (
        <GlobalMinimalHeader
          content={header as unknown as GlobalMinimalHeaderContent}
        />
      );
    case 'globalNav':
      return <GlobalNavigationWrapper content={header as GlobalNavContent} />;
    case 'header': {
      return <LegacyHeader content={header as HeaderContent} />;
    }
    default:
      return null;
  }
}
